import React from "react";
import PropTypes from "prop-types";
import './index.css'
const ChaloButton = (props)=>(
<button className='chalo-button-container'
    onClick={props.onClick} 
    disabled={props.disabled}
    style={{ opacity: props.disabled ? "40%" : "100%" }}
 >
        <span>{props.buttonText}</span>
</button>

);

ChaloButton.defaultProps = {
    buttonText: '',
    disabled: false,
    onClick: ()=> {
    }
}
;
ChaloButton.propTypes = {
    buttonText: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool
};
export default ChaloButton;